import { Platform } from 'react-native'
import { isDevice } from 'expo-device'
import { useMemo } from 'react'

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
let ExpoConfig: any

const logging = false

export const getExpoConfig = (refresh = false) => {
  if (ExpoConfig && !refresh) return ExpoConfig

  // In web or simulator, we want the dynamic values from `app.json`, not the ones in the iOS build
  if (Platform.OS === 'web' || (__DEV__ && !isDevice)) {
    const config = require('../../../app.json')
    ExpoConfig = config.expo
  } else {
    // const config = (await import('expo-constants')).default
    const config = require('expo-constants').default
    ExpoConfig = config.expoConfig
  }

  if (logging) {
    const {
      version,
      extra: { channel, branch } = {}
    } = ExpoConfig

    console.log('useConfig CONFIG', { os: Platform.OS, version, channel, branch })
  }

  return ExpoConfig
}

export const useConfig = () => {
  const config = useMemo(() => {
    const expoConfig = getExpoConfig()
    if (logging) console.log('useConfig HOOK', expoConfig)
    return expoConfig
  }, [])
  return config
}
